// import { StateReducers } from 'state/reducers/types/StateReducers'

import {
  // NewMessageFileFieldConnectedProps,
  NewMessageFileFieldMapStateReturnType,
} from './types'

export const NewMessageFileFieldMapState = (): // state: StateReducers,
// props: NewMessageFileFieldConnectedProps,
NewMessageFileFieldMapStateReturnType => {
  // const currentLocation = state.currentLocation || undefined
  // const isRoutes = currentLocation && currentLocation.isRoutes
  // return { isRoutes }

  return {}
}
